import { AddressDto } from "./CommonInterfaces";

const DEFAULT_COMMON_ADDRESS: AddressDto = {
  street: "",
  unitNumber: "",
  city: "",
  province: "",
  postalCode: "",
  country: "CANADA",
  majorIntersection: "",
  entranceInstructions: "",
} as AddressDto;

export { DEFAULT_COMMON_ADDRESS };
